import { Vector3 } from 'three';
import { EOpeningDirection, EOrientation } from '../../@types/Enums';
import { DEFAULT_DOOR_LENGTH } from '../../utils/constants';
import Entity, { IEntity } from '../abstract/Entity';
import { IAttribute } from './AttributeModel';
import { getDefaultObjectId, ObjectType } from '../../utils/attributes/defaultObjectsAndAttributes';

export interface IDoor extends IEntity {
  position: Vector3;
  length: number;
  depth: number;
  angle: number;
  openingDirection: EOpeningDirection;
  orientation: EOrientation;
}

class DoorModel extends Entity implements IDoor {
  position: Vector3;

  length: number;

  depth: number;

  angle: number;

  openingDirection: EOpeningDirection;

  orientation: EOrientation;

  readonly filesApiId: number | undefined = getDefaultObjectId(ObjectType.Door);

  constructor(
    position: Vector3,
    length: number = DEFAULT_DOOR_LENGTH,
    depth: number = 1,
    angle: number = 0,
    openingDirection: EOpeningDirection = EOpeningDirection.RIGHT,
    orientation: EOrientation = EOrientation.INWARD,
    attributes: Array<IAttribute> = [],
    uuid: string | undefined = undefined,
  ) {
    super(attributes);
    if (uuid) {
      this.uuid = uuid;
    }
    this.position = position;
    this.length = length;
    this.depth = depth;
    this.angle = angle;
    this.openingDirection = openingDirection;
    this.orientation = orientation;
  }

  getPosition(): Vector3 {
    return this.position;
  }

  setPosition(position: Vector3): void {
    this.position = position;
  }

  getLength(): number {
    return this.length;
  }

  setLength(length: number): void {
    this.length = length;
  }

  getDepth(): number {
    return this.depth;
  }

  setDepth(depth: number): void {
    this.depth = depth;
  }

  getAngle(): number {
    return this.angle;
  }

  setAngle(angle: number): void {
    this.angle = angle;
  }

  getOpeningDirection(): EOpeningDirection {
    return this.openingDirection;
  }

  setOpeningDirection(openingDirection: EOpeningDirection): void {
    this.openingDirection = openingDirection;
  }

  getOrientation(): EOrientation {
    return this.orientation;
  }

  setOrientation(orientation: EOrientation): void {
    this.orientation = orientation;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      position: { x: this.position.x, y: this.position.y, z: this.position.z },
      length: this.length,
      depth: this.depth,
      angle: this.angle,
      openingDirection: this.openingDirection,
      orientation: this.orientation,
    };
  }
}

export default DoorModel;
